import React from "react";
import App from "./App";
import AuthProvider from "../../auth/AuthProvider";

function RootComponent() {
  return (
    <AuthProvider>
      <App />
    </AuthProvider>
  );
}

export default RootComponent;
